import { Stack, Typography } from '@mui/material';

import { currencyFormat } from 'helpers/utils';
import { castArray, isNumber } from 'lodash-es';
import type { FC } from 'react';
import {
  CoverageTableFirstHeaderStackStyle,
  CoverageTableHeaderStackStyle,
} from './CoverageTableHeader.styles';
import type { CoverageTableHeaderProps } from './CoverageTableHeader.types';

const CoverageTableHeader: FC<CoverageTableHeaderProps> = ({
  tableData,
  isFirstHeader,
  ...rest
}) => (
  <Stack
    {...rest}
    sx={[
      CoverageTableHeaderStackStyle,
      isFirstHeader ? CoverageTableFirstHeaderStackStyle : {},
      ...castArray(rest.sx),
    ]}
  >
    <Stack gap={0.5}>
      <Typography variant="h3">{tableData.title}</Typography>

      <Typography variant="body1">{tableData.subtitle || ''}</Typography>
    </Stack>

    <Stack alignSelf="end" flex={1}>
      {tableData?.additionalData?.map((item) => (
        <Stack flexDirection="row" gap={1.5} justifyContent="end" flex={1} key={item.label}>
          <Typography variant="h3" whiteSpace="nowrap">
            {item.label}
          </Typography>

          <Typography variant="body1" whiteSpace="nowrap">
            {isNumber(item.value) ? currencyFormat(item.value, undefined, true).merged : item.value}
          </Typography>
        </Stack>
      ))}
    </Stack>
  </Stack>
);

export default CoverageTableHeader;
